//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../axios/axios.js'
import ReportMaterialsDebits from './ReportMaterialsDebits.vue'
import ReportMaterialsDemountings from './ReportMaterialsDemountings.vue'
import ReportMaterialsMountings from './ReportMaterialsMountings.vue'
import ReportMaterialsConsumptions from './ReportMaterialsConsumptions.vue'
import ReportContentSection from '../ReportContent/ReportContentSection.vue'

export default {
  components: {
    ReportMaterialsDebits,
    ReportMaterialsConsumptions,
    ReportMaterialsDemountings,
    ReportMaterialsMountings,
    ReportContentSection
  },
  props: {
    reportId: {
      type: Number,
      default: null
    },
    reportName: {
      type: String,
      default: null
    },
    materialesAvailable: {
      type: Array,
      default () {
        return []
      }
    },
    standardSpecification: {
      type: Array,
      default () {
        return []
      }
    },
    checking: {
      type: Boolean,
      default: false
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    },
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    },
    projects: {
      type: Array,
      default () {
        return []
      }
    },
    contentParentId: {
      type: String,
      default: 'section-materials'
    },
    contentIdSuffix: {
      type: String,
      default: ''
    },
    contentWeightBase: {
      type: Number,
      default: 1200
    }
  },
  data: function () {
    const materialsGroups = this.report._materialsGroups
    const debitsGroup = materialsGroups.getGroup('debits')
    return {
      materialsGroups,

      showMountingsAndDemountings: false,
      get debitError () {
        return debitsGroup.debitError
      },

      materialsCollapse: [],
      defaultOpenCollapse: {
        consumptions: false,
        demountings: false,
        mountings: false,
        debits: false,
        generalDemountings: false
      },
      tags: []
    }
  },
  computed: {
    reportActionsAccessGeneralDemounting: function () {
      const access = JSON.parse(JSON.stringify(this.reportActionsAccess))
      access.editMaterials = access.editGeneralDemounting
      return access
    }
  },
  created: function () {
    this.updateMaterials()
    this.getTags()
  },
  methods: {
    updateMaterials: function (updateMaterialsAvailable = false) {
      this.showMountingsAndDemountings = this.report.isFieldIncluded('mountingsAndDemountings')
      if (this.showMountingsAndDemountings) {
        this.loadMaterialsGroup('demountings', (records) => {
          return this.serviceObject && records.find(record => record.serviceObjectKey === this.serviceObject.key) != null
        })
        this.loadMaterialsGroup('mountings')
      }
      this.loadMaterialsGroup('debits')
      this.loadMaterialsGroup('consumptions')

      if (updateMaterialsAvailable) {
        this.$emit('update-materials')
      }
    },
    onAddOperationMounting: function (operation) {
      this.$refs.mountings.onAddOperationMounting(operation)
    },
    onAddOperationReplacement: function (operation) {
      this.$refs.mountings.onAddOperationReplacement(operation)
    },
    onChangeMaterialesAvailable: function (materialesAvailable) {
      this.$emit('change-materiales-available', materialesAvailable)
    },
    onMaterialsRemarks: function (groupKey) {
      const remarks = this.materialsGroups.getGroup(groupKey).allRemarks
      this.$emit(groupKey + '-remarks', remarks)
    },
    loadMaterialsGroup: function (groupKey, expandConditionFn) {
      const materialsGroup = this.materialsGroups.getGroup(groupKey)
      materialsGroup.loadRecords().then(() => {
        const records = materialsGroup.records
        const expand = expandConditionFn ? expandConditionFn(records) : records.length
        if (expand) {
          this.materialsCollapse.push(groupKey)
          this.defaultOpenCollapse[groupKey] = true
          this.$emit('collapse')
        }
        this.onMaterialsRemarks(groupKey)
      })
    },
    getTags: function () {
      axiosGet({
        url: '/service/obj/search?returnFields=key,name,id&type=recordTag&add=description',
        onSuccess: (response) => {
          this.tags = response.data.result
        },
        onFailure: 'Ошибка получения тегов'
      })
    },
    getOpenExpansion: function (total) {
      return total > 0
    }
  }
}

